{
  "schemaVersion": 3,
  "generatedAt": "2026-08-21T03:23:25.131Z",
  "status": "calibrated",
  "engineGeneration": "v5.0-twelve-guardians",
  "methodology": "十二位角色先使用與正式網站相同的紅黑方加權開局棋譜；脫譜後阿芽使用 V1，鐵算盤、雷駒與赤刃使用本機教師蒸餾的 V1-Pro，烈風之後（包含兵陣青穗）使用 Pikafish 2026-01-02；三種引擎都先依 lossBudget 建立強度候選池，再只在池內按棋風重排。標準初始局面、紅黑互換完整全循環每組至少 4 局，相鄰組至少加密 100 局；Bradley-Terry/Elo 最大概似估計；對局 bootstrap 95% 信賴區間。正式發布另要求十二階單調、最小相鄰差至少 40 Elo、最大 CI 半寬不超過 60 Elo。",
  "poolAnchor": "十二位對手平均固定為 1200；這是雲端將族 v5 的站內相對棋力，不等同人類協會或其他平台 Elo。",
  "benchmark": {
    "cpu": "Intel(R) Core(TM) Ultra X7 358H",
    "logicalCores": 16,
    "platform": "win32 10.0.26200",
    "node": "v24.15.0",
    "pikafish": "2026-01-02 AVX2"
  },
  "hybridConfig": {
    "attacker": {
      "nodes": 2200,
      "multiPV": 11,
      "lossBudget": 155,
      "blunderRate": 0.06,
      "blunderBudget": 420,
      "temperature": 26,
      "style": "attack"
    },
    "defender": {
      "nodes": 3000,
      "multiPV": 11,
      "lossBudget": 145,
      "blunderRate": 0.06,
      "blunderBudget": 420,
      "temperature": 24,
      "style": "defense"
    },
    "pawn": {
      "nodes": 4300,
      "multiPV": 10,
      "lossBudget": 128,
      "blunderRate": 0.045,
      "blunderBudget": 355,
      "temperature": 21,
      "style": "pawn"
    },
    "miser": {
      "nodes": 5200,
      "multiPV": 9,
      "lossBudget": 115,
      "blunderRate": 0.04,
      "blunderBudget": 320,
      "temperature": 20,
      "style": "safety"
    },
    "blockader": {
      "nodes": 6800,
      "multiPV": 9,
      "lossBudget": 105,
      "blunderRate": 0.038,
      "blunderBudget": 315,
      "temperature": 20,
      "style": "blockade"
    },
    "scholar": {
      "nodes": 9500,
      "multiPV": 8,
      "lossBudget": 75,
      "blunderRate": 0.02,
      "blunderBudget": 220,
      "temperature": 17,
      "style": "book"
    },
    "veteran": {
      "nodes": 12000,
      "multiPV": 8,
      "lossBudget": 80,
      "blunderRate": 0.025,
      "blunderBudget": 250,
      "temperature": 17,
      "style": "endgame"
    },
    "master": {
      "nodes": 25000,
      "multiPV": 7,
      "lossBudget": 55,
      "blunderRate": 0.015,
      "blunderBudget": 200,
      "temperature": 15,
      "style": "balanced"
    }
  },
  "styleEnabled": true,
  "gamesPerPair": 4,
  "adjacentGames": 300,
  "monotonic": true,
  "minimumAdjacentGap": 50,
  "adjacentGaps": [
    {
      "lower": "beginner",
      "upper": "trader",
      "gap": 250
    },
    {
      "lower": "trader",
      "upper": "cannonhorse",
      "gap": 70
    },
    {
      "lower": "cannonhorse",
      "upper": "gambiteer",
      "gap": 90
    },
    {
      "lower": "gambiteer",
      "upper": "attacker",
      "gap": 90
    },
    {
      "lower": "attacker",
      "upper": "defender",
      "gap": 50
    },
    {
      "lower": "defender",
      "upper": "pawn",
      "gap": 100
    },
    {
      "lower": "pawn",
      "upper": "miser",
      "gap": 70
    },
    {
      "lower": "miser",
      "upper": "blockader",
      "gap": 80
    },
    {
      "lower": "blockader",
      "upper": "scholar",
      "gap": 110
    },
    {
      "lower": "scholar",
      "upper": "veteran",
      "gap": 90
    },
    {
      "lower": "veteran",
      "upper": "master",
      "gap": 210
    }
  ],
  "behaviorMetrics": {
    "beginner": {
      "games": 344,
      "checksPerGame": 1.32,
      "capturesPerGame": 4.74,
      "majorCapturesPerGame": 2.41,
      "retreatsPerGame": 9.76,
      "pawnAdvancesPerGame": 4.28,
      "advisorElephantMovesPerGame": 4.9,
      "cannonHorseMovesPerGame": 18.41,
      "bookMovesPerGame": 2.33,
      "offeredPiecesPerGame": 6.46,
      "pawnCrossingsPerGame": 1.23,
      "mobilitySuppressionPerGame": 91.72
    },
    "trader": {
      "games": 644,
      "checksPerGame": 3.63,
      "capturesPerGame": 8.9,
      "majorCapturesPerGame": 3.65,
      "retreatsPerGame": 9.22,
      "pawnAdvancesPerGame": 6.75,
      "advisorElephantMovesPerGame": 5.13,
      "cannonHorseMovesPerGame": 18.65,
      "bookMovesPerGame": 2.59,
      "offeredPiecesPerGame": 6.01,
      "pawnCrossingsPerGame": 1.89,
      "mobilitySuppressionPerGame": 154.82
    },
    "cannonhorse": {
      "games": 644,
      "checksPerGame": 4.14,
      "capturesPerGame": 8.46,
      "majorCapturesPerGame": 3.62,
      "retreatsPerGame": 9.97,
      "pawnAdvancesPerGame": 5.51,
      "advisorElephantMovesPerGame": 5.39,
      "cannonHorseMovesPerGame": 19.39,
      "bookMovesPerGame": 2.45,
      "offeredPiecesPerGame": 5.95,
      "pawnCrossingsPerGame": 1.48,
      "mobilitySuppressionPerGame": 165.58
    },
    "gambiteer": {
      "games": 644,
      "checksPerGame": 4.07,
      "capturesPerGame": 9.26,
      "majorCapturesPerGame": 3.72,
      "retreatsPerGame": 6.73,
      "pawnAdvancesPerGame": 6.82,
      "advisorElephantMovesPerGame": 3.23,
      "cannonHorseMovesPerGame": 17.04,
      "bookMovesPerGame": 3.82,
      "offeredPiecesPerGame": 5.36,
      "pawnCrossingsPerGame": 1.78,
      "mobilitySuppressionPerGame": 150.09
    },
    "attacker": {
      "games": 644,
      "checksPerGame": 3.01,
      "capturesPerGame": 7.4,
      "majorCapturesPerGame": 3.35,
      "retreatsPerGame": 8.46,
      "pawnAdvancesPerGame": 5.81,
      "advisorElephantMovesPerGame": 5.73,
      "cannonHorseMovesPerGame": 19.11,
      "bookMovesPerGame": 3.23,
      "offeredPiecesPerGame": 7.27,
      "pawnCrossingsPerGame": 1.49,
      "mobilitySuppressionPerGame": 144.49
    },
    "defender": {
      "games": 644,
      "checksPerGame": 2.75,
      "capturesPerGame": 8.44,
      "majorCapturesPerGame": 4.17,
      "retreatsPerGame": 12.35,
      "pawnAdvancesPerGame": 4.26,
      "advisorElephantMovesPerGame": 12.49,
      "cannonHorseMovesPerGame": 18.89,
      "bookMovesPerGame": 1.52,
      "offeredPiecesPerGame": 8.5,
      "pawnCrossingsPerGame": 1.04,
      "mobilitySuppressionPerGame": 129.82
    },
    "pawn": {
      "games": 644,
      "checksPerGame": 3.07,
      "capturesPerGame": 9.33,
      "majorCapturesPerGame": 3.86,
      "retreatsPerGame": 7.65,
      "pawnAdvancesPerGame": 11.84,
      "advisorElephantMovesPerGame": 5.95,
      "cannonHorseMovesPerGame": 16.94,
      "bookMovesPerGame": 1.54,
      "offeredPiecesPerGame": 11.63,
      "pawnCrossingsPerGame": 3.18,
      "mobilitySuppressionPerGame": 145.39
    },
    "miser": {
      "games": 644,
      "checksPerGame": 2.95,
      "capturesPerGame": 8.58,
      "majorCapturesPerGame": 3.99,
      "retreatsPerGame": 13.91,
      "pawnAdvancesPerGame": 5.31,
      "advisorElephantMovesPerGame": 10.86,
      "cannonHorseMovesPerGame": 21.27,
      "bookMovesPerGame": 0.81,
      "offeredPiecesPerGame": 9.55,
      "pawnCrossingsPerGame": 1.39,
      "mobilitySuppressionPerGame": 145.88
    },
    "blockader": {
      "games": 644,
      "checksPerGame": 4.03,
      "capturesPerGame": 8.71,
      "majorCapturesPerGame": 3.98,
      "retreatsPerGame": 10.22,
      "pawnAdvancesPerGame": 6.2,
      "advisorElephantMovesPerGame": 6.51,
      "cannonHorseMovesPerGame": 21.2,
      "bookMovesPerGame": 1.9,
      "offeredPiecesPerGame": 8.97,
      "pawnCrossingsPerGame": 1.82,
      "mobilitySuppressionPerGame": 167.5
    },
    "scholar": {
      "games": 644,
      "checksPerGame": 3.53,
      "capturesPerGame": 8.68,
      "majorCapturesPerGame": 3.97,
      "retreatsPerGame": 9.23,
      "pawnAdvancesPerGame": 6.77,
      "advisorElephantMovesPerGame": 7.15,
      "cannonHorseMovesPerGame": 20.07,
      "bookMovesPerGame": 4.11,
      "offeredPiecesPerGame": 9.39,
      "pawnCrossingsPerGame": 1.77,
      "mobilitySuppressionPerGame": 152.79
    },
    "veteran": {
      "games": 644,
      "checksPerGame": 3.16,
      "capturesPerGame": 8.73,
      "majorCapturesPerGame": 3.95,
      "retreatsPerGame": 8.54,
      "pawnAdvancesPerGame": 7.65,
      "advisorElephantMovesPerGame": 6.34,
      "cannonHorseMovesPerGame": 17.94,
      "bookMovesPerGame": 4.05,
      "offeredPiecesPerGame": 9.22,
      "pawnCrossingsPerGame": 2.03,
      "mobilitySuppressionPerGame": 145.54
    },
    "master": {
      "games": 344,
      "checksPerGame": 4.44,
      "capturesPerGame": 10.06,
      "majorCapturesPerGame": 4.63,
      "retreatsPerGame": 8.82,
      "pawnAdvancesPerGame": 5.99,
      "advisorElephantMovesPerGame": 6.07,
      "cannonHorseMovesPerGame": 19.68,
      "bookMovesPerGame": 3.77,
      "offeredPiecesPerGame": 7.56,
      "pawnCrossingsPerGame": 1.55,
      "mobilitySuppressionPerGame": 176.92
    }
  },
  "runProvenance": {
    "addedGames": 660,
    "adjacentOffset": 240,
    "resumedGames": 2904
  },
  "totalGames": 3564,
  "maxPlies": 160,
  "bootstrapSamples": 1500,
  "maxCiHalfWidth": 60,
  "decisiveRate": 0.7129629629629629,
  "outcomes": {
    "redWins": 1543,
    "draws": 1023,
    "blackWins": 998
  },
  "elapsedMs": 1491109,
  "ratings": {
    "beginner": {
      "rating": 590,
      "ciLow": 530,
      "ciHigh": 650,
      "games": 344,
      "wins": 29,
      "draws": 62,
      "losses": 253
    },
    "trader": {
      "rating": 840,
      "ciLow": 800,
      "ciHigh": 890,
      "games": 644,
      "wins": 282,
      "draws": 182,
      "losses": 180
    },
    "cannonhorse": {
      "rating": 910,
      "ciLow": 870,
      "ciHigh": 950,
      "games": 644,
      "wins": 161,
      "draws": 278,
      "losses": 205
    },
    "gambiteer": {
      "rating": 1000,
      "ciLow": 960,
      "ciHigh": 1030,
      "games": 644,
      "wins": 200,
      "draws": 227,
      "losses": 217
    },
    "attacker": {
      "rating": 1090,
      "ciLow": 1060,
      "ciHigh": 1120,
      "games": 644,
      "wins": 249,
      "draws": 171,
      "losses": 224
    },
    "defender": {
      "rating": 1140,
      "ciLow": 1110,
      "ciHigh": 1170,
      "games": 644,
      "wins": 217,
      "draws": 160,
      "losses": 267
    },
    "pawn": {
      "rating": 1240,
      "ciLow": 1210,
      "ciHigh": 1280,
      "games": 644,
      "wins": 264,
      "draws": 155,
      "losses": 225
    },
    "miser": {
      "rating": 1310,
      "ciLow": 1270,
      "ciHigh": 1340,
      "games": 644,
      "wins": 206,
      "draws": 222,
      "losses": 216
    },
    "blockader": {
      "rating": 1390,
      "ciLow": 1350,
      "ciHigh": 1420,
      "games": 644,
      "wins": 223,
      "draws": 192,
      "losses": 229
    },
    "scholar": {
      "rating": 1500,
      "ciLow": 1460,
      "ciHigh": 1540,
      "games": 644,
      "wins": 266,
      "draws": 153,
      "losses": 225
    },
    "veteran": {
      "rating": 1590,
      "ciLow": 1550,
      "ciHigh": 1640,
      "games": 644,
      "wins": 214,
      "draws": 161,
      "losses": 269
    },
    "master": {
      "rating": 1800,
      "ciLow": 1740,
      "ciHigh": 1860,
      "games": 344,
      "wins": 230,
      "draws": 83,
      "losses": 31
    }
  }
}
